import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as Rx from 'rxjs';
import { AppSettingService } from '../app.service';
import { UserInfoService } from '../user/user-info.service';

export interface IUserZone {
	Client: string,
	DisplayName: string,
	AllowSignup: boolean,
	JobProvider: any[],
	AllowAvatarImageChange: boolean,
	AllowCoverImageChange: boolean,
	DefaultAvatarImage: string,
	DefaultCoverImage: string,
	Logo: string,
	IsPublic: boolean,
	IsJAZone: boolean,
	SkillsGap: boolean,
	JobPosting: boolean
}

export class UserZone implements IUserZone {
	Client: string = "";
	DisplayName: string = "";
	AllowSignup: boolean = false;
	JobProvider: any[] = null;
	AllowAvatarImageChange: boolean = false;
	AllowCoverImageChange: boolean = false;
	DefaultAvatarImage: string = "";
	DefaultCoverImage: string = "";
	Logo: string = "";
	IsPublic: boolean = false;
	IsJAZone: boolean = false;
	SkillsGap: boolean = false;
	JobPosting: boolean = false;
}


@Injectable({
	providedIn: 'root'
})
export class ZoneAPIService {
	constructor(
		private userInfo: UserInfoService,
		private http: HttpClient
	) { }

	private url = AppSettingService.appConfig.JourneyAPIUrl + "Zone";

	getUserZone(): Rx.Observable<IUserZone> {
		return this.http.get<IUserZone>(
			this.url + "/UserZone",
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfo.authHeader(false) }
			}
		);
	}

	allowCreateConnection(): Rx.Observable<any> {
		return this.http.get <any>(
			this.url + "/AllowCreateConection",
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfo.authHeader(false) }
			}
		);
	}

	getZone(zoneName: string): Rx.Observable<any> {
		return this.http.get<any>(
			this.url + "/Name/" + encodeURIComponent(zoneName)
		);
	}

	searchZone(zoneName: string, limit: number = 100, offset: number = 0): Rx.Observable<any>  {
		return this.http.get<any>(
			this.url + "/Search?keyword=" + encodeURIComponent(zoneName) + "&limit=" + limit.toString() + "&offset=" + offset.toString()
		);
	}

	getStatus(): Rx.Observable<any> {
		return this.http.get<any>(
			this.url + "/Status",
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfo.authHeader(false) }
			}
		);
	}

	getPublicZone(): Rx.Observable<any> {
		return this.http.get<any>(
			this.url + "/PublicZone"
		);
	}
}
